import { css } from "@emotion/react";

interface LoaderProps {
  height?: number;
  width?: number;
  type?: string;
  flex?: string;
  style?: React.CSSProperties;
}

const Loader: React.FC<LoaderProps> = ({
  height = 12,
  width = 12,
  type = "dark",
  flex = "1",
  style = {},
}) => (
  <div css={styles.loaderContainer(flex)} style={style}>
    <div css={styles.loader(type, width)} style={{ height, width }}></div>
  </div>
);

const styles = {
  loaderContainer: (flex: string) => css`
    display: flex;
    flex: ${flex};
    flex-direction: column;
    height: 100%;
    align-items: center;
    justify-content: center;
  `,
  loader: (type: string, width: number) => css`
    @keyframes spin {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
    border-radius: 50%;
    border: ${Number(width) / 6}px solid
      ${type !== "light"
        ? type === "voilet"
          ? "rgb(166, 74, 247,0.24)"
          : type === "dark"
          ? "rgb(0, 0, 0,0.24)"
          : "rgba(255, 255, 255, 0.24)"
        : "rgba(0, 0, 0, 0.24)"};
    border-left-color: ${type !== "light"
      ? type === "voilet"
        ? "rgb(166, 74, 247,1)"
        : type === "dark"
        ? "rgb(0, 0, 0, 1)"
        : "rgba(255, 255, 255, 1)"
      : "rgba(0, 0, 0, 1)"};
    animation: spin 1s linear infinite;
  `,
};

export default Loader;
